import TileWMS from 'ol/source/TileWMS';
// import Text from 'ol/style/Text';
// import Fill from 'ol/style/Fill';
// import Stroke from 'ol/style/Stroke';
import { PROXY_PREFIX, allAdminLayers } from './admin';
import { baseLayers } from './base';
import { fertilityLayers } from './fertility';
import { adolescentBirthLayers,populationLayers } from './population';
export { PROXY_PREFIX };

export const allLayersList = [
    ...Object.values(baseLayers),
    ...allAdminLayers,
    ...Object.values(fertilityLayers),
    ...Object.values(adolescentBirthLayers),
    ...Object.values(populationLayers),
];

export const tileWMSLayers = allLayersList.filter(layer => layer.getSource().constructor===TileWMS)

export const getCheckboxInfoFromLayer = layer =>
{
    return {
        id: layer.get("id"),
        visible: layer.getVisible(),
        titleNepali: layer.get("titleNepali"),
        titleEnglish: layer.get("titleEnglish"),
        legendPath: layer.get("legendPath"),
        sourceInfo: layer.get("sourceInfo"),
        description: layer.get("description"),
        sourceInfoNepali: layer.get("sourceInfoNepali"),
        descriptionNepali: layer.get("descriptionNepali"),
    };
};

// export const adminGroupCheckboxInfo = {
//     id: 'admin-layers',
//     title: 'Admin layers',
//     titleNepali: 'प्रशासनीय तहहरु',
//     iconPath: 'http://mep.pathway.com.np/static/img/baseLayer.svg',
//     layerInfos: Object.values(adminLayers).map(getCheckboxInfoFromLayer)
// };

// export const updateMunicipalityStyle = () => 
// {
//     let getStyle;
//     if (populationLayers.municipality.getVisible())
//     {
//         getStyle = populationLayers.municipality.getStyle();
//     }
//     else if (fertilityLayers.municipality.getVisible())
//     {
//         getStyle = fertilityLayers.municipality.getStyle();
//     }
//     else
//     {
//         // resetMunicipalityStyle();
//         return;
//     }
//     adminLayers.municipality.setStyle( (feature,resolution) =>
//     {
//         if (resolution < 0.001)
//         {
//             const style = getStyle(feature);
//             style.setText(new Text({
//                 text: feature.get('GaPa_NaPa'),
//                 fill: new Fill({color: 'black'}),
//                 stroke: new Stroke({color: 'rgba(255,255,255,1)', width: 2}),
//             }));
//             return style;
//         }
//         return;
//     });
// };

